import React, { Fragment } from "react";

import CheckoutCard from "app/checkout/CheckoutCard";
import styles from "./PaymentDetailsBlock.module.scss";
import { CreditCardImages, addressLinesFromAddress } from "shared/utility";

/**
 * The cardholder name and the billing address are drawn in the design but the
 * checkout never captures either — the Stripe card element is mounted without
 * `billing_details`, and `billing_address` comes back null. Both are gated on
 * the data actually being there, so the card is correct today and fills itself
 * in if the API starts returning them.
 */
const PaymentDetailsBlock = ({ amountPaid, billingAddress, card, className }) => {
  if (!card) {
    return null;
  }

  const brandImage =
    CreditCardImages.Regular[card.brand] || CreditCardImages.Blank.Generic;

  return (
    <CheckoutCard className={className}>
      <div>
        <p className="gkit-p-17 gkit-mobile-15 gkit-bold gkit-mt-0 gkit-mb-3">
          Payment details
        </p>

        <img className={styles.brand} alt={card.label} src={brandImage} />

        {card.label && (
          <p className="gkit-p-15 gkit-mobile-13 gkit-mt-2 gkit-mb-0">
            {card.label}
          </p>
        )}

        {card.name && (
          <p className="gkit-p-15 gkit-mobile-13 gkit-my-0">{card.name}</p>
        )}

        {card.last4 && (
          <p className="gkit-p-15 gkit-mobile-13 gkit-my-0">****{card.last4}</p>
        )}

        {amountPaid && (
          <p className="gkit-p-15 gkit-mobile-13 gkit-my-0">
            {amountPaid.formatted}
          </p>
        )}

        {billingAddress && (
          <>
            <hr className={styles.divider} />

            <p className="gkit-p-17 gkit-mobile-15 gkit-bold gkit-mt-0 gkit-mb-2">
              Billing address
            </p>
            <p className="gkit-p-15 gkit-mobile-13 gkit-light gkit-m-0">
              {addressLinesFromAddress(billingAddress).map((line, idx) => (
                <Fragment key={String(idx)}>
                  {idx > 0 && <br />}
                  {line}
                </Fragment>
              ))}
            </p>
          </>
        )}
      </div>
    </CheckoutCard>
  );
};

export default PaymentDetailsBlock;
